var map = {
	"./sub-1.png": "2125",
	"./sub-1_active.png": "8883",
	"./sub-2.png": "9fcb",
	"./sub-2_active.png": "fca79",
	"./sub-3.png": "b6fa",
	"./sub-3_active.png": "6bde",
	"./sub-active.png": "5d5f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "05c2";